import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';
import { isAuthenticated } from '@/lib/auth';

interface AuthGuardProps {
  children: React.ReactNode;
}

/**
 * Protected route wrapper. Redirects to /login if no valid token exists.
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated: reduxAuth } = useAppSelector((s) => s.auth);
  const location = useLocation();

  // Check both Redux state and localStorage (for page refreshes)
  const hasToken = reduxAuth || isAuthenticated();

  if (!hasToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
